/*! Tom Greenhill - app.js */

import '../scss/app.scss'
import { domReady } from './utilities/helpers.js'
import framework from './framework.js'

function start() {
  framework()
}

domReady(start)
